<template>
  <div :class="['app ' + $route.name]">
    <Transition>
      <div v-if="pageLoaded && currentLanguage" id="page" class="page">
        <Transition>
          <MobMenu
            v-if="menuVisible"
            :currency-code="currencyCode"
            :currency-symbol="currencySymbol"
            :currency-options="currencyOptions"
            :currency-code-id="currencyCodeId"
            :cart-contents="cartContents"
            :is-auth="isAuth"
            @changeCurrency="changeCurrency"
            @openSignUp="openSignUp"
            @closeMenu="closeMenu"
            @openSellSkinModal="openSellSkinModal"
            @openSignIn="openSignIn"
            @openCartCheckout="openCartCheckout"
          />
        </Transition>
        <div
          :class="['mob menu-icon', { active: menuVisible }]"
          @click="toggleMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
        <Header
          :currency-code="currencyCode"
          :currency-options="currencyOptions"
          :currency-code-id="currencyCodeId"
          :cart-contents="cartContents"
          :is-auth="isAuth"
          @changeCurrency="changeCurrency"
          @openSignIn="openSignIn"
          @openSignUp="openSignUp"
          @removeOneFromCart="removeOneFromCart"
          @openSellSkinModal="openSellSkinModal"
          @openCartCheckout="openCartCheckout"
        />
        <router-view
          :minTopupAmount="minTopupAmount"
          :currency-code="currencyCode"
          :lang="currentLanguage"
          :currency-symbol="currencySymbol"
          :text-page-title="textPageTitle"
          :text-page-header="textPageHeader"
          :text-page-content="textPageContent"
          :is-auth="isAuth"
          :order-history="orderHistory"
          :total-sum="totalSum"
          :error="error"
          :cart-contents="cartContents"
          :hostname="hostname"
          :footer-support-email="footerSupportEmail"
          :chosen-item="chosenItem"
          @formatDate="formatDate"
          @goToProduct="goToProduct"
          @openSignUp="openSignUp"
          @openSellSkinModal="openSellSkinModal"
          @openSignIn="openSignIn"
          @logout="logout"
          @addToCart="addToCart"
          @removeOneFromCart="removeOneFromCart"
          @removeFromCart="removeFromCart"
          @openOrderModal="openOrderModal"
          @openWithdraw="openWithdraw"
        />
        <Footer
          :isAuth="isAuth"
          :text-page-list="textPageList"
          :footer-requisites="footerRequisites"
          :footer-support-email="footerSupportEmail"
          :footerCopyright="footerCopyright"
          :paymentMethods="allPaymentMethods"
          @openSignIn="openSignIn"
          @openSellSkinModal="openSellSkinModal"
        />
        <Transition>
          <ProductModal
            v-if="productModalIsVisible"
            :product-page-item="productPageItem"
            :currency-code="currencyCode"
            :currency-symbol="currencySymbol"
            :chosen-item="chosenItem"
            :error="error"
            :loader-is-visible="loaderIsVisible"
            @closeProductModal="closeProductModal"
            @addToCart="addToCart"
          />
        </Transition>
        <Transition>
          <LoginModal
            v-if="signInModalIsVisible"
            :error="error"
            :successMessage="successMessage"
            :loader-is-visible="loaderIsVisible"
            :showResendOption="showResendOption"
            @closeSignIn="closeSignIn"
            @openSignUp="openSignUp"
            @login="login"
            @forgotPass="forgotPass"
            @clearError="clearError"
            @hideResendOption="hideResendOption"
            @resendVerificationEmail="resendVerificationEmail"
          />
        </Transition>
        <Transition>
          <RegistrationModal
            v-if="signUpModalIsVisible"
            :error="error"
            :loader-is-visible="loaderIsVisible"
            @closeSignUp="closeSignUp"
            @openSignIn="openSignIn"
            @registration="registration"
          />
        </Transition>
        <Transition>
          <OrderModal
            v-show="orderModalIsVisible"
            :orderData="orderData"
            :payment-methods="availablePaymentMethods"
            :error="error"
            @orderSubmit="orderSubmit"
            @closeOrderModal="closeOrderModal"
          />
        </Transition>
        <Transition>
          <SellSkinModal
            v-if="sellSkinModalIsVisible"
            @setError="setError"
            @openOrderModal="openOrderModal"
            :error="error"
            @closeSellSkinModal="closeSellSkinModal"
          />
        </Transition>
        <Transition>
          <PayoutModal
            v-if="withdrawModalIsVisible"
            :currencyCode="currencyCode"
            :currency-symbol="currencySymbol"
            @closeWithdraw="closeWithdraw"
            @openSignIn="openSignIn"
          />
        </Transition>
        <Transition>
          <CartCheckoutModal
            :user="user"
            v-if="cartCheckoutModalIsVisible"
            @closeCartCheckout="closeCartCheckout"
          />
        </Transition>

        <CookiesModal />
      </div>
    </Transition>
  </div>
</template>

<script>
import Header from "./components/HeaderComponent.vue";
import Footer from "./components/FooterComponent.vue";
import ProductModal from "./components/ProductModal.vue";
import CartCheckoutModal from "./components/CartCheckoutModal.vue";
import MobMenu from "./components/MobMenu.vue";
import LoginModal from "./components/LoginModal.vue";
import RegistrationModal from "./components/RegistrationModal.vue";
import OrderModal from "./components/OrderModal.vue";
import CookiesModal from "./components/CookiesModal.vue";
import { loadScriptsFromString } from "@/utils/load_scripts";
import { mapActions, mapGetters, mapState } from "vuex";
import {
  TERMS_PAGE,
  PRIVACY_PAGE,
  COOKIE_PAGE,
} from "@/store/modules/staticPages";
import SellSkinModal from "./components/SellSkinModal.vue";
import PayoutModal from "./components/PayoutModal.vue";

export default {
  name: "App",
  components: {
    SellSkinModal,
    PayoutModal,
    Header,
    Footer,
    ProductModal,
    MobMenu,
    LoginModal,
    RegistrationModal,
    OrderModal,
    CookiesModal,
    CartCheckoutModal,
  },
  data: function () {
    return {
      isAuth: false,
      showResendOption: false,
      currencyCodeId: "",
      currencyOptions: [],
      pageLoaded: false,
      error: "",
      productModalIsVisible: false,
      productPageItem: {},
      textPageList: [],
      textPageTitle: "",
      textPageHeader: "",
      textPageContent: "",
      menuVisible: false,
      signInModalIsVisible: false,
      signUpModalIsVisible: false,
      successMessage: "",
      totalSum: "",
      chosenItem: "",
      loaderIsVisible: false,
      orderHistory: [],
      orderModalIsVisible: false,
      orderData: {},
      allPaymentMethods: [],
      availablePaymentMethods: [], // Store available payment methods for the current order
      checkoutIsSubmitting: false,
      minTopupAmount: 0,
      hostname: "",
      cookesModalIsVisible: false,

      footerCopyright: "",
      withdrawModalIsVisible: false,
      sellSkinModalIsVisible: false,
      cartCheckoutModalIsVisible: false,
    };
  },
  computed: {
    ...mapState("app", ["currentLanguage"]),
    ...mapGetters("app", ["currencyCode", "currencySymbol"]),
    ...mapGetters("cart", ["cartContents"]),
    ...mapGetters("staticPages", ["getPageByType"]),
    ...mapGetters("modals", ["depositModalIsVisible", "cartDropdownIsVisible"]),
  },
  watch: {
    currentLanguage() {
      this.getTextPages();
    },
    currencyCode() {
      if (this.productPageItem && this.productPageItem.length) {
        this.getProductPageContent(this.productPageItem);
      }
      if (this.isAuth) {
        this.orderHistory = "";
        this.cartContents = "";
        this.totalSum = "";
        // this.getOrderHistory();
        this.fetchCartItems();
        this.fetchUserData();
      }
    },
    $route() {
      this.error = "";
      window.scrollTo(0, 0);
      this.closeMenu();
      this.closeCartDropdown();
      if (this.isAuth) {
        // this.getOrderHistory();
      }
    },
  },
  methods: {
    clearError() {
      this.error = "";
    },
    setError(error) {
      this.error = error;
    },
    closeCartCheckout() {
      this.cartCheckoutModalIsVisible = false;
      document.body.style.overflow = "auto";
    },
    openCartCheckout() {
      this.cartCheckoutModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    openSellSkinModal() {
      this.sellSkinModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeSellSkinModal() {
      this.sellSkinModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.error = "";
    },
    closeWithdraw() {
      this.withdrawModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.error = "";
    },
    openWithdraw() {
      this.withdrawModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    ...mapActions("app", ["fetchCurrencies", "changeCurrency"]),
    ...mapActions("modals", [
      "closeDepositModal",
      "openCartDropdown",
      "closeCartDropdown",
    ]),
    ...mapActions("user", ["fetchUserData"]),
    ...mapActions("cart", [
      "fetchCartItems",
      "clearCart",
      "updateCartContents",
    ]),
    ...mapActions("staticPages", ["fetchPages", "fetchPageContent"]),
    async fetchPaymentMethods(countryId, currencyCode) {
      this.$http
        .post(process.env.VUE_APP_API + "orders/payment-methods", {
          country: countryId,
          currency: currencyCode,
        })
        .then((response) => {
          if (response.data.status === "OK") {
            this.availablePaymentMethods = response.data.payload;
          } else {
            this.error = this.$t(response.data.message);
          }
        })
        .catch((error) => {
          console.error("Error fetching payment methods:", error);
          this.error = this.$t("Error fetching payment methods");
        });
    },
    resendVerificationEmail(data) {
      this.error = "";
      this.$http
        .post(process.env.VUE_APP_API + "resendConfirmationLink", {
          email: data,
        })
        .then((res) => {
          if (res.data.status == "OK") {
            this.error = "";
            this.successMessage = this.$t("Confirmation link has been resent.");
          } else {
            this.error = this.$t(res.data.message);
            this.successMessage = "";
          }
        })
        .catch((res) => {
          this.error = this.$t(res.response.data.message);
        });
    },
    getDomainName(hostName) {
      return hostName.substring(
        hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1,
      );
    },
    orderSubmit(data, type) {
      if (this.checkoutIsSubmitting) return;

      this.checkoutIsSubmitting = true;
      data.paymentType = type;
      data.currency = this.currencyCode;
      data.directPayment = true;
      this.$http
        .post(process.env.VUE_APP_API + "purchase/product", data)
        .then((res) => {
          if (res.data.status == "ERROR") {
            this.$router.push({ name: "PaymentFailPage" });
            this.checkoutIsSubmitting = false;
            this.closeOrderModal();
          } else {
            window.location = res.data.redirect_url;
          }
        })
        .catch((res) => {
          this.checkoutIsSubmitting = false;
          this.$toast.error(this.$t(res.response.data.message), {
            multiple: false,
          });
          this.error = this.$t(res.response.data.message);
        });
    },
    closeOrderModal() {
      this.orderModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.error = "";
      this.checkoutIsSubmitting = false;
    },
    openOrderModal(data) {
      this.orderModalIsVisible = true;
      document.body.style.overflow = "hidden";
      this.orderData = data;
      this.fetchPaymentMethods(this.orderData.country, this.currencyCode);
    },
    // getOrderHistory() {
    //   this.$http
    //     .get(process.env.VUE_APP_API + "orders/history")
    //     .then((res) => {
    //       this.orderHistory = res.data.payload;
    //     })
    //     .catch((res) => {
    //       if (res.response.status === 401) {
    //         this.openSignIn();
    //       }
    //     });
    // },
    addToCart(item) {
      if (!this.isAuth) {
        this.openSignIn();
      } else {
        let self = this;

        let cartItem = {
          id: item.id,
          count: 1,
        };

        for (var i = 0; i < this.cartContents.length; i++) {
          if (this.cartContents[i].item_id == item.id) {
            let cartItemCount = this.cartContents[i].count;
            cartItem = {
              ...cartItem,
              count: cartItemCount + 1,
            };
            break;
          }
        }
        this.loaderIsVisible = true;
        this.$http
          .post(process.env.VUE_APP_API + "cart/add", cartItem)
          .then((res) => {
            self.loaderIsVisible = false;
            self.fetchCartItems();
            self.chosenItem = cartItem.id;
            self.updateCartContents(res.data.cart);
            setTimeout(() => {
              self.chosenItem = "";
            }, 2000);
          })
          .catch((res) => {
            self.loaderIsVisible = false;
            if (res.response.status === 401) {
              this.openSignIn();
            } else {
              self.error = this.$t(res.response.data.message);
              setTimeout(() => {
                self.error = "";
              }, 2000);
            }
          });
      }
    },
    removeOneFromCart(item) {
      let self = this;
      let cartItem = {
        id: item.id,
        count: "1",
      };
      if (item.count > 1) {
        cartItem = {
          ...cartItem,
          count: item.count - 1,
        };
        this.$http
          .post(process.env.VUE_APP_API + "cart/add", cartItem)
          .then(() => {
            self.fetchCartItems();
          })
          .catch(() => {});
      } else {
        this.removeFromCart(item);
      }
    },

    removeFromCart(item) {
      let self = this;
      let cartItem = {
        id: item.id,
      };
      this.$http
        .post(process.env.VUE_APP_API + "cart/remove", cartItem)
        .then(() => {
          self.fetchCartItems();
        })
        .catch(() => {});
    },
    checkIsAuth() {
      this.$http
        .get(process.env.VUE_APP_API + "is-auth")
        .then((res) => {
          this.isAuth = res.data.authenticated;
          if (res.data.authenticated) {
            this.fetchCartItems();
            // this.getOrderHistory();
            this.fetchUserData();
          }
        })
        .catch(() => {});
    },
    login(data) {
      this.loaderIsVisible = true;
      this.showResendOption = false;

      this.$http
        .post(process.env.VUE_APP_API + "login", data)
        .then((res) => {
          this.loaderIsVisible = false;
          if (res.data.status == "OK") {
            this.isAuth = true;
            this.closeSignIn();
            this.fetchCartItems();
            // this.getOrderHistory();
            this.fetchUserData();
          } else {
            this.error = this.$t(res.data.message);
          }
        })
        .catch((res) => {
          this.loaderIsVisible = false;
          this.error = this.$t(res.response.data.message);
          if (res.response.data.status === "VERIFY") {
            this.showResendOption = true;
          }
        });
    },
    forgotPass(data) {
      let self = this;
      self.loaderIsVisible = true;
      return this.$http
        .post(process.env.VUE_APP_API + "user/reset-password", data)
        .then((res) => {
          self.loaderIsVisible = false;
          console.log(res.data, "data");

          if (res.data.status == "OK") {
            self.successMessage = res?.data?.message
              ? this.$t(res?.data?.message)
              : "Success";
            self.error = "";
            setTimeout(() => {
              self.successMessage = "";
            }, 2500);
          } else {
            this.error = this.$t(res.response.data.message);
          }
        })
        .catch((error) => {
          self.loaderIsVisible = false;
          this.error = this.$t(error.response.data.message);
        });
    },
    registration(data) {
      if (
        !/^[a-zA-Z\s-]+$/.test(data.name) ||
        !/^[a-zA-Z\s-]+$/.test(data.surname)
      ) {
        this.error = this.$t(
          "First name and Last name must only contain letters",
        );
        return;
      }
      let self = this;
      self.loaderIsVisible = true;
      this.$http
        .post(process.env.VUE_APP_API + "register", data)
        .then((res) => {
          self.loaderIsVisible = false;
          if (res.data.status == "OK") {
            self.clearError();
            self.isAuth = true;
            self.closeSignUp();
            self.fetchCartItems();
            // self.getOrderHistory();
          } else {
            self.error = this.$t(res.data.message);
          }
        })
        .catch((res) => {
          self.loaderIsVisible = false;
          this.error = this.$t(res.response.data.message);
        });
    },
    logout() {
      this.$http
        .post(process.env.VUE_APP_API + "logout")
        .then(() => {
          if (this.$route.name != "Home") {
            this.$router.push({ path: "/" });
          }
          this.isAuth = false;
          this.$router.push({ path: "/" });
        })
        .catch((res) => {
          if (res.response.status === 401) {
            console.log(res);
          }
        });
    },
    openSignIn() {
      this.error = "";
      this.showResendOption = false;
      this.signUpModalIsVisible = false;
      this.signInModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeSignIn() {
      this.error = "";
      this.showResendOption = false;
      this.signInModalIsVisible = false;
      this.signUpModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.clearError();
    },
    openSignUp() {
      this.error = "";
      this.showResendOption = false;
      this.signInModalIsVisible = false;
      this.signUpModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeSignUp() {
      this.error = "";
      this.showResendOption = false;
      this.signUpModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.clearError();
    },
    getProductPageContent(item) {
      this.productPageItem = "";
      const apiEndpoint = `items/${item.id}`;
      this.$http
        .get(`${process.env.VUE_APP_API}${apiEndpoint}`, {
          params: { currency: this.currencyCode },
        })
        .then((res) => {
          this.productPageItem = res.data.payload;
        })
        .catch((error) => {
          this.error = this.$t("Failed to load product data.");
          console.error(error);
        });
    },
    goToProduct(item) {
      const id = item.id;
      this.$router.push({ name: "ProductPage", params: { id: id } });
    },
    openProductModal() {
      this.productModalIsVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeProductModal() {
      this.productModalIsVisible = false;
      document.body.style.overflow = "auto";
      this.clearError();
    },
    hideResendOption() {
      this.showResendOption = false;
    },
    getTextPages() {
      this.fetchPages(this.currentLanguage);
    },
    closeMenu() {
      this.menuVisible = false;
      document.body.style.overflow = "auto";
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
      window.scrollTo(0, 0);
      if (this.menuVisible) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
    },
    menuHeight() {
      const doc = document.documentElement;
      doc.style.setProperty("--vh", `${window.innerHeight * 0.01}px`);
    },
    getSettings() {
      this.$http
        .get(process.env.VUE_APP_API + "settings")
        .then((res) => {
          this.minTopupAmount = res.data.payload.min_top_up;
          this.allPaymentMethods = res.data.payload.payment_methods;
          this.footerRequisites = res.data.payload.requisites;
          this.footerSupportEmail = res.data.payload.support_email;
          this.footerCopyright = res.data.payload.copyright;
          const snippet = res.data.payload.google_tag;
          if (snippet) {
            loadScriptsFromString(snippet);
          }
        })
        .catch(() => {});
    },
    ...mapActions("app", ["fetchLanguages"]),
  },
  created() {
    // Make constants available in template
    this.TERMS_PAGE = TERMS_PAGE;
    this.PRIVACY_PAGE = PRIVACY_PAGE;
    this.COOKIE_PAGE = COOKIE_PAGE;
  },
  mounted: async function () {
    let self = this;
    self.fetchLanguages();
    this.fetchCurrencies();
    self.getTextPages();
    self.menuHeight();
    self.getSettings();
    self.checkIsAuth();
    self.hostname = self.getDomainName(window.location.hostname);
    window.addEventListener("resize", self.menuHeight);
    setTimeout(function () {
      self.pageLoaded = true;
    }, 300);
  },
};
</script>
